import { css } from 'linaria';

export const questionAccordion = css`
  && {
    width: 877px;

    @media (--to-desktop) {
      width: 100%;
    }
  }
`;

export const questionText = css`
  margin-bottom: 8px;
`;

export const questionList = css`
  padding: 0 0 0 26px;
  margin: 0;
`;

export const questionListItem = css`
  position: relative;
  margin-bottom: 8px;
  white-space: break-spaces;
`;
